/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkIncidentCompleteRequest
 */
export interface MarkIncidentCompleteRequest {
    /**
     * 
     * @type {string}
     * @memberof MarkIncidentCompleteRequest
     */
    pin: string;
}

/**
 * Check if a given object implements the MarkIncidentCompleteRequest interface.
 */
export function instanceOfMarkIncidentCompleteRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pin" in value;

    return isInstance;
}

export function MarkIncidentCompleteRequestFromJSON(json: any): MarkIncidentCompleteRequest {
    return MarkIncidentCompleteRequestFromJSONTyped(json, false);
}

export function MarkIncidentCompleteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkIncidentCompleteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pin': json['pin'],
    };
}

export function MarkIncidentCompleteRequestToJSON(value?: MarkIncidentCompleteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pin': value.pin,
    };
}

